import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SessionService } from '../../services/session.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})

export class SidebarComponent implements OnInit {
  isSidebarHidden = false;
  sidebarEL: HTMLElement | null = null;
  mainEL: HTMLElement | null = null;
  filteredSidebarItems: any[] = [];
  sidebarItems: any = [
    {
      name: 'Resumen',
      link: '/app/dashboard',
      icon: 'team_dashboard'
    },
    {
      name: 'Monitoreo',
      link: '/app/monitoring',
      icon: 'space_dashboard'
    },
    {
      name: 'Pacientes',
      link: '/app/patients',
      icon: 'personal_injury'
    },
    {
      name: 'Tomas',
      link: '/app/measurement',
      icon: 'glucose'
    },
    {
      name: 'Usuarios',
      link: '/app/users',
      icon: 'group'
    },
    {
      name: 'Perfiles',
      link: '/app/profiles',
      icon: 'manufacturing'
    },
  ];

  constructor(
    private sessionService: SessionService,
  ) {}

  ngOnInit() {    
    this.sidebarEL = document.getElementById("sidebar");
    this.mainEL = document.getElementById("main");
    this.init();
    this.updateSidebar();
  }

  updateSidebar(): void {
    const userViews = this.sessionService.getUserViews();
  
    this.filteredSidebarItems = this.sidebarItems.filter((item: any) =>
      userViews.some((view: any) => view.includes(item.link.replace('/app/', '')))
    );
  }

  init() {
    // add event listener to sidebar
    document
      .querySelectorAll(".burger-btn")
      .forEach((el) => el.addEventListener("click", this.toggle.bind(this)))
    document
      .querySelectorAll(".sidebar-hide")
      .forEach((el) => el.addEventListener("click", this.toggle.bind(this)))
    window.addEventListener("resize", this.onResize.bind(this))


    const toggleSubmenu = (el: any) => {
      if (el.classList.contains("submenu-open")) {
        el.classList.remove('submenu-open')
        el.classList.add('submenu-closed')
      } else {
        el.classList.remove("submenu-closed")
        el.classList.add("submenu-open")
      }
    }

    let sidebarItems = document.querySelectorAll(".sidebar-item.has-sub")

    for (var i = 0; i < sidebarItems.length; i++) {
      let sidebarItem = sidebarItems[i];

      const sidebarLink = sidebarItem?.querySelector(".sidebar-link");

      if (sidebarLink) {
        sidebarLink.addEventListener("click", (e) => {
          e.preventDefault();
          const submenu = sidebarItem?.querySelector(".submenu");
          if (submenu) {
            toggleSubmenu(submenu);
          }
        });
      }

      // If submenu has submenu
      const submenuItems = sidebarItem.querySelectorAll('.submenu-item.has-sub')
      submenuItems.forEach(item => {
        item.addEventListener('click', () => {
          const submenuLevelTwo = item.querySelector('.submenu')
          toggleSubmenu(submenuLevelTwo)

          // Pass second .submenu
          //const height = this.calculateChildrenHeight(item.parentElement, true)

        })
      })
    }

    // Perfect Scrollbar Init
    // if (typeof PerfectScrollbar == "function") {
    //   const container = document.querySelector(".sidebar-wrapper")
    //   const ps = new PerfectScrollbar(container, {
    //     wheelPropagation: true,
    //   })
    // }

    // Scroll into active sidebar
    setTimeout(() => {
      const activeSidebarItem = document.querySelector(".sidebar-item.active");
      if (activeSidebarItem) {
        this.forceElementVisibility(activeSidebarItem);
      }
      this.show();
    }, 300);

  }

  /**
 * Toggle Sidebar
 */
  toggle() {
    const sidebarState = this.sidebarEL?.classList.contains("active");
    
    if (sidebarState) {
      this.hide()
    } else {
      this.show()
    }
  }

  /**
 * Show Sidebar
 */
  show() {
    this.sidebarEL?.classList.add("active");
    this.sidebarEL?.classList.remove("inactive");
    this.mainEL?.classList.add("sidebar-open");
    this.createBackdrop()
    this.toggleOverflowBody()
  }

  /**
   * Hide Sidebar
   */
  hide() {
    this.sidebarEL?.classList.remove("active");
    this.sidebarEL?.classList.add("inactive");
    this.mainEL?.classList.remove("sidebar-open");
    this.deleteBackdrop()
    this.toggleOverflowBody()
  }

  /**
* On Sidebar Rezise Event
*/
  onResize() {
    if (this.isDesktop(window)) {
      this.sidebarEL?.classList.add("active")
      this.sidebarEL?.classList.remove("inactive")
    } else {
      this.sidebarEL?.classList.remove("active")
    }

    // reset
    this.deleteBackdrop()
    this.toggleOverflowBody(true)
  }

  isDesktop(window: any) {
    return window.innerWidth > 1200;
  }

  hasItems(item: any) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  onCloseMenu() {
    this.isSidebarHidden = !this.isSidebarHidden;
  }

  calculateChildrenHeight = (el: any, deep = false) => {
    const children = el.children

    let height = 0
    for (let i = 0; i < el.childElementCount; i++) {
      const child = children[i]
      height += child.querySelector('.submenu-link').clientHeight

      // 2-level menu
      if (deep && child.classList.contains('has-sub')) {
        const subsubmenu = child.querySelector('.submenu')

        if (subsubmenu.classList.contains('submenu-open')) {
          const childrenHeight = ~~[...subsubmenu.querySelectorAll('.submenu-link')].reduce((acc, curr) => acc + curr.clientHeight, 0)
          height += childrenHeight
        }
      }

    }
    el.style.setProperty('--submenu-height', height + 'px')
    return height
  }

  /**
   * On First Load
   */
  onFirstLoad() {
    if (!this.sidebarEL) return
    if (this.isDesktop(window)) {
      this.sidebarEL.classList.add("active")
      this.sidebarEL.classList.add('sidebar-desktop')
    }

    // Get submenus size
    let submenus = document.querySelectorAll(".sidebar-item.has-sub .submenu")
    for (var i = 0; i < submenus.length; i++) {
      let submenu = submenus[i]
      const sidebarItem = submenu.parentElement
      const height = submenu.clientHeight

      if (sidebarItem && sidebarItem.classList.contains('active')) submenu.classList.add('submenu-open')
      else submenu.classList.add('submenu-closed')
      // setTimeout(() => {
      //   const height = this.calculateChildrenHeight(submenu, true)
      // }, 50);
    }
  }

  forceElementVisibility(el: any) {
    if (!this.isElementInViewport(el)) {
      el.scrollIntoView(false)
    }
  }

  isElementInViewport(el: any) {
    var rect = el.getBoundingClientRect()

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    )
  }

  /**
 * Toggle Overflow Body
 */
  toggleOverflowBody(active?: any) {
    if (this.isDesktop(window)) return;
    const sidebarState = this.sidebarEL?.classList.contains("active");
    const body: any = document.querySelector("body");

    if (typeof active == "undefined") {
      body.style.overflowY = sidebarState ? "hidden" : "auto";
    } else {
      body.style.overflowY = active ? "auto" : "hidden";
    }
  }

  /**
 * Create Sidebar Backdrop
 */
  createBackdrop() {
    if (this.isDesktop(window)) return
    this.deleteBackdrop()
    const backdrop = document.createElement("div")
    backdrop.classList.add("sidebar-backdrop")
    backdrop.addEventListener("click", this.hide.bind(this))
    document.body.appendChild(backdrop)
  }

  /**
   * Delete Sidebar Backdrop
   */
  deleteBackdrop() {
    const backdrop = document.querySelector(".sidebar-backdrop")
    if (backdrop) {
      backdrop.remove()
    }
  }


}
